import grayLogo from "../../../Assets/valut-logo-dark.png";
import goldLogo from "../../../Assets/valut-logo-gold.png";

/** Intrinsic SVG viewBox — keep aspect ratio; never stretch with a fixed height. */
const LOGO_ASPECT = 123 / 26;

const LOGO_ASSETS = {
  dark: grayLogo,
  gold: goldLogo,
};

export const ValutWordmarkLogo = ({
  width = 160,
  height,
  className = "",
  onDark = false,
  variant = "dark",
}) => {
  const isGoldVariant = variant === "gold";
  const src = isGoldVariant ? LOGO_ASSETS.gold : LOGO_ASSETS.dark;
  const resolvedWidth = Number(width) || 160;
  const maxHeight =
    height != null && Number(height) > 0
      ? Number(height)
      : Math.round(resolvedWidth / LOGO_ASPECT);

  return (
    <img
      src={src}
      alt="VALUT"
      width={123}
      height={26}
      className={`valut-wordmark-logo${
        onDark || isGoldVariant ? " valut-wordmark-logo--on-dark" : ""
      }${!isGoldVariant ? " valut-wordmark-logo--brand-dark" : ""} ${className}`.trim()}
      style={{
        display: "block",
        width: resolvedWidth,
        maxWidth: "100%",
        height: "auto",
        maxHeight,
        objectFit: "contain",
        objectPosition: "left center",
      }}
    />
  );
};
